import React, { useEffect, useState } from "react";
import { cleanedData } from "../../network/cipAPI";
import Charts from "../../FileUpload/chart";
import HistoricalCIPS from "../historicalCIPS";
import { connect, useDispatch, useSelector } from "react-redux";
import PageLoading from "../../components/PageLoading";
import { storeCIPS } from "../../Store/TemplateStore/template.action";
import CriticalDeleteDialog from "../../components/CriticalDeleteDialog";
import moment from "moment";
import { useTranslation } from "react-i18next";

const IdentifyCIP = ({
  cips,
  duplicateCip,
  setDuplicateCip,
  activeStep,
  setSegmentedCips,
  segmentedCips,
}) => {
  const { t } = useTranslation();
  const [date, setPlotDate] = useState(useSelector((state) => state.cleanDate));
  const [cleaningResponse, setCleaningResponse] = useState(
    useSelector((state) => state.cleanData)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [duplicateCIPStartDate, setDuplicateCIPStartDate] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (duplicateCip) {
      const startDate = Object.values(duplicateCip).map((item) => {
        return duplicateCip ? moment(item).format("DD/MM/YYYY") : "";
      });
      setDuplicateCIPStartDate(startDate);
    }
  }, [duplicateCip]);

  const getCleanedData = async () => {
    try {
      setIsLoading(true);
      const response = await cleanedData();
      console.log(response);
      const data = JSON.parse(response?.data?.cleaned_data);
      const segmented_cips = response?.data?.cip_data;
      setSegmentedCips(segmented_cips);
      setIsLoading(false);
      const date = data.date;
      setPlotDate(date);
      setCleaningResponse(data);
      dispatch({
        type: "STORE_CLEAN_DATA",
        payload: {
          cleanData: data,
          cleanDate: date,
        },
      });
    } catch (err) {
      console.error("getCleanedData", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!cleaningResponse) {
      getCleanedData();
    }
  }, []);

  const onBackClicked = () => {
    setDuplicateCip(false);
  };

  return (
    <div>
      <div className="descriptionText marginTop10 marginBtm10">
        {t("IdentifiedCIPStrings.chartDescription")}
      </div>
      <HistoricalCIPS />

      {isLoading ? (
        <PageLoading customHeight={"215px"} />
      ) : (
        <div className="chart">
          <Charts
            cleaningResponse={cleaningResponse}
            date={date}
            cips={segmentedCips}
            activeStep={activeStep}
          />
        </div>
      )}
      <div className="descriptionText marginTop10 marginBtm10">
        {t(
          "cleaningEffectivnessStrings.disclaimerText"
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cips: state.cips,
});

const mapDispatchToProps = {
  storeCIPS,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentifyCIP);
